import { useTranslation } from "react-i18next";
import { MessageAttachment } from "../../features/messages/models/MessageAttachment";
import { MessagesChannel } from "../../features/messages/models/MessagesChannel";
import AttachmentRow from "./AttachmentRow";
import InlineImage from "./InlineImage";
import { useOpenAttachment } from "./useOpenAttachment";
import VideoRow from "./VideoRow";

interface MessageAttachmentsProps {
  attachments: MessageAttachment[];
  channel: MessagesChannel;
}

/** A message's attachments in order: photos inline, files as rows, videos as rows that play in place. */
const MessageAttachments = ({ attachments, channel }: MessageAttachmentsProps) => {
  const { t } = useTranslation();
  const { download } = useOpenAttachment(channel);
  if (attachments.length === 0) return null;

  return (
    <div className="mt-2 flex flex-col gap-2">
      {attachments.map((attachment) => {
        if (attachment.kind === "Image") {
          return <InlineImage key={attachment.id} attachment={attachment} channel={channel} />;
        }
        if (attachment.kind === "Video") {
          return <VideoRow key={attachment.id} attachment={attachment} channel={channel} />;
        }
        return (
          <AttachmentRow
            key={attachment.id}
            attachment={attachment}
            actionLabel={t("materials.downloadAction")}
            onAction={() => void download(attachment.id)}
          />
        );
      })}
    </div>
  );
};

export default MessageAttachments;
